// 261023 E3-P3h2/3 — Button của workbench: chỉ CTA chính (`cta`) mới được đỏ (`primary`/`danger`); mọi nút khác tự hạ về trung tính (`demoteBtn`, hàm thuần có jest).
// Dùng thay `Button` của antd ở các thành phần TRONG trang. Hộp xác nhận (Modal.confirm) dùng `okButtonProps` riêng nên không đi qua đây.
import React from 'react';
import { Button as AntButton } from 'antd';
import type { ButtonProps } from 'antd';
import { demoteBtn } from './wbButtonView';

export interface WbButtonProps extends ButtonProps {
  /** CTA chính của chỗ dừng (đúng một ở mỗi màn): giữ nguyên `type="primary"` / `danger`. */
  cta?: boolean;
}

const WbButton = React.forwardRef<HTMLElement, WbButtonProps>(({ cta = false, type, danger, ghost, ...rest }, ref) => {
  const look = demoteBtn({ type: type as never, danger, ghost }, cta);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <AntButton ref={ref as any} {...rest} type={look.type as ButtonProps['type']} danger={look.danger} ghost={look.ghost} />;
});
WbButton.displayName = 'WbButton';

export default WbButton;
